import React, { FormEventHandler } from 'react';
import Radio from '@mos-cat/radio';
import { Heading, Paragraph } from '@mos-cat/typography';
import { t, Trans } from '@lingui/macro';
import { PERSON_FIELD_NAME } from '../../../constants/fieldNames';
import { Field } from '../../../declarations/widget-ums';
import { CHANGE_NAME } from '../../../constants/child';
import { i18n } from '../../../helpers/i18n';

export type ChangeName = CHANGE_NAME.match | CHANGE_NAME.notMatch;

export interface NameChangeRadioProps {
  changeName: Field<CHANGE_NAME | null>;
  isNameChangedToggle: FormEventHandler;
  model: string;
}

function NameChangeRadio({
  changeName,
  model,
  isNameChangedToggle,
}: NameChangeRadioProps): JSX.Element {
  const name = `${model}/${PERSON_FIELD_NAME.changeName}`;
  const { value, error } = changeName;
  return (
    <div className="StepContentBlock NameChangeRadio">
      <Heading level={3} className="PguFormGrid__row">
        <Trans>Сведения о перемене фамилии, имени, отчества</Trans>
      </Heading>
      <Paragraph className="PguFormGrid__row">
        <Trans id="form/changeName/title">
          Фамилия, имя, отчество, указанные в документе, удостоверяющем
          личность, совпадают с данными, указанными в других документах?
        </Trans>
      </Paragraph>
      <div className="PguFormGrid__row">
        <Radio
          className="PguFormGrid_col"
          label={i18n._(t`Совпадают`)}
          name={name}
          value={CHANGE_NAME.match}
          checked={value === CHANGE_NAME.match}
          onChange={isNameChangedToggle}
          error={error}
        />
      </div>
      <div className="PguFormGrid__row">
        <Radio
          className="PguFormGrid_col"
          label={i18n._(t`Не совпадают`)}
          name={name}
          value={CHANGE_NAME.notMatch}
          checked={value === CHANGE_NAME.notMatch}
          onChange={isNameChangedToggle}
          error={error}
        />
      </div>
    </div>
  );
}

export default NameChangeRadio;
